import { type User, signInWithCustomToken } from "firebase/auth";
import { getFirebase } from "./init.js";

export interface MintResponse {
  firebase_custom_token: string;
  discord_uid: string;
  exp: number;
}

export async function exchangeForCustomToken(input: {
  brokerUrl: string;
  discordAccessToken: string;
  fetchImpl?: typeof fetch;
}): Promise<MintResponse> {
  const fetchImpl = input.fetchImpl ?? fetch;
  const res = await fetchImpl(input.brokerUrl, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ discord_access_token: input.discordAccessToken }),
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`mint failed: ${res.status} ${text.slice(0, 200)}`);
  }
  return (await res.json()) as MintResponse;
}

export async function signIntoFirebase(customToken: string): Promise<User> {
  const { auth } = getFirebase();
  const cred = await signInWithCustomToken(auth, customToken);
  return cred.user;
}
